import { NeutralColor } from "node-library/dist/colors";
import React from "react";

interface NavbarProps {
	items: Array<{ label: string; onClick: () => void; isCurrentItem: boolean }>;
}

function NavBar(props: NavbarProps) {
	return (
		<div className="navbar">
			{props.items.map(
				(
					item: { label: string; onClick: () => void; isCurrentItem: boolean },
					index: number
				) => {
					return (
						<React.Fragment key={item.label}>
							<span
								className="typography-caption"
								style={{
									color: item.isCurrentItem
										? NeutralColor.NEUTRAL_GREY_950
										: NeutralColor.NEUTRAL_GREY_600,
									cursor: "pointer",
								}}
								onClick={item.onClick}
							>
								{item.label}
							</span>
							{index < props.items.length - 1 && (
								<span style={{ color: NeutralColor.NEUTRAL_GREY_600 }}>/</span>
							)}
						</React.Fragment>
					);
				}
			)}
		</div>
	);
}

export { NavBar };
